import { blog as config } from "~/config/blog";
import fetchJson from "~/utils/Fetch/json";
import { replaceInItem } from "~/utils/Blog/replaceTerms";

export const getPage = async ({ slug, id }) => {
  let base = "pages/";
  if (id) {
    base += `${id}/`;
  }

  if (slug) {
    base += `slug/${slug}`;
  }

  const url = config.url(base);
  const result = await fetchJson(url);
  if (result?.data?.pages) {
    result.data.pages = result.data.pages.map(replaceInItem);
  }
  return result;
};
